import {BadgeIndianRupee } from 'lucide-react'
import React from 'react'
import { Link } from 'react-router-dom'


const FinancialButtonsmb = () => {
  return (
      <>
          
      <div className="flex w-[100%] sm:hidden block justify-center items-center z-50 font-bold">
        <Link to={"/balance-overview"} className="flex items-center  w-[50%] justify-center space-x-1 p-2 bg-green-700 text-white text-xs hover:bg-green-700 transition-colors duration-300">
          <BadgeIndianRupee size={15} className='' />
          
          <span>Deposit</span>
        </Link>
        <Link to={"/withdraw"} className="flex items-center justify-center w-[50%] space-x-1 p-2 bg-[#910707] text-white text-xs transition-colors duration-300">
          <BadgeIndianRupee size={15} />
          <span>Withdrawal</span>
        </Link>
      </div>
    </>
  )
}

export default FinancialButtonsmb
